export default __webpack_public_path__ + "static/media/industry_white.370f553e.svg";